<template>
  <div class="mx-n2">

    <error-dialog :status="loadStatus" />

    <dialog-scroll-lock v-if="show && html" width="420" :value="true" @input="html = null">
      <v-card>
        <v-btn class="float-right ma-3" icon @click="show = null">
          <v-icon v-html="mdiClose" />
        </v-btn>
        <v-card-title v-text="TITLES[show]" />
        <v-card-text v-html="html" />
      </v-card>
    </dialog-scroll-lock>

    <v-btn class="px-2" text x-small color="primary" :loading="(show == 'description') && !html" @click="show = 'description'">
      <v-icon class="mr-1" x-small v-html="mdiInformation" /> Description
    </v-btn>
    <v-btn class="px-2" text x-small color="primary" :loading="(show == 'disclosure') && !html" @click="show = 'disclosure'">
      <v-icon class="mr-1" x-small v-html="mdiFileDocument" /> Terms & conditions
    </v-btn>
  </div>
</template>


<script>
import loadScript from '@/utils/load-script.js';
import { mdiFileDocument, mdiInformation, mdiClose } from '@mdi/js';

const DEFAULT_MSG = '<a href="/faq#how-do-gift-cards-work" target="_blank">How gift cards work</a>';

const TITLES = {
  description: 'Description',
  disclosure: 'Terms & conditions'
};

export default {
  name: 'giftcard-details',

  props: [ 'src', 'productId' ],

  data() {
    return {
      show: null,
      html: null,
      loadStatus: this.$track('load')
    };
  },

  created() {
    Object.assign(this, { TITLES, mdiFileDocument, mdiInformation, mdiClose });
  },

  methods: {
    async load() {
      const giftcard = await this.$call('get-giftcard', { provider: this.src, id: this.productId });
      if (giftcard[this.show])
        return giftcard[this.show];
      const url = giftcard[this.show + '_url_md'];
      if (!url)
        return DEFAULT_MSG;
      const tasks = [ loadScript('/lib/drawdown.min.js'), fetch(url).then(x => x.text()) ];
      const md = (await Promise.all(tasks))[1];
      return markdown(md);
    }
  },

  watch: {
    async show(v) {
      this.html = v ? (await this.load()) : null;
    }
  }
}
</script>
